import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import formatDistance from 'date-fns/formatDistance';

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

/**
 * Receive timestamp and timezone as optional param, return a formatted date
 * @param timestamp
 * @param timezone
 */
const formatTimestamp = (
  timestamp: number,
  timezone?: string,
  format?: 'full' | 'short'
) => {
  const date = dayjs(timestamp * 1000);
  if (timezone) {
    const dateWithTz = date.tz(timezone);
    if (format === 'full') {
      return dateWithTz.format('YYYY/MM/DD HH:mm:ss');
    }
    if (format === 'short') {
      return dateWithTz.format('D MMM');
    }
    return dateWithTz.format('DD.MM.YY HH:mm:ss');
  }

  if (format === 'full') {
    return date.format('YYYY/MM/DD HH:mm:ss');
  }
  if (format === 'short') {
    return date.format('D MMM');
  }

  return date.format('DD.MM.YY HH:mm:ss');
};

const timeDistance = (time: string | number | Date) => {
  const [value, period] = formatDistance(new Date(), new Date(time))
    .replace('about ', '')
    .split(' ');
  return `${value} ${period}`;
};
/**
 * ^^^ Similar formatting as above but without seconds
 */
const formatTimestampNoSeconds = (timestamp: number) =>
  dayjs(timestamp * 1000).format('HH:mm DD.MM.YY');

/**
 * Receive timestamp in string and return a formatted date
 * @param timestamp
 */
const formatTimestampTime = (timestamp: number | string) => {
  if (typeof timestamp === 'number') {
    return dayjs(timestamp * 1000).format('HH:mm:ss');
  }

  return dayjs(timestamp).format('HH:mm:ss');
};

const formatTx = (tx: string) =>
  `${tx.slice(0, 4)}...${tx.slice(tx.length - 4, tx.length)}`;

const formatNumber = (number: number) => number.toLocaleString('en');

const toFixed2 = (number: number | string) => Number(number).toFixed(2);
const toFixed3 = (number: number | string) => Number(number).toFixed(3);
const toFixed4 = (number: number | string) => Number(number).toFixed(4);
const toFixed6 = (number: number | string) => Number(number).toFixed(6);

const toMath4 = (number: number | string) =>
  Math.round(Number(number) * 10000) / 10000;

export {
  formatTimestamp,
  formatTimestampNoSeconds,
  formatTimestampTime,
  timeDistance,
  formatNumber,
  toFixed2,
  toFixed3,
  toFixed4,
  toFixed6,
  toMath4,
  formatTx,
};
